import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth, sendPasswordResetEmail } from 'config/firebase';
import PasswordResetVector from 'assets/svg/logo.svg';
import Helmet from 'components/Helmet';
import TextInput from 'components/TextInput';
import Button from 'components/Button';
import { useAppDispatch } from 'hooks/useStore';
import { setAlert } from 'store/error';
import './index.css';

function PasswordReset() {
    const [email, setEmail] = useState('');
    const [emailSent, setEmailSent] = useState(false);

    const dispatch = useAppDispatch();

    const resetPassword = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        sendPasswordResetEmail(auth, email)
            .then(() => {
                setEmailSent(true);
            })
            .catch(error => {
                // console.log(error.message);
                dispatch(setAlert({
                    response: {
                        data: {
                            message: error.message
                        }
                    }
                }));
            });
    }

    return (
        <div className='layout'>
            <Helmet
                title='Reset your Password | PrepSharp Students'
            />
            <form className='passwordReset' onSubmit={resetPassword}>
                <img
                    className='passwordReset__vector'
                    src={PasswordResetVector}
                    alt='Password Reset'
                />
                <h2 className='passwordReset__vectorText'>
                    Student Login
                </h2>
                <h1 className='passwordReset__header'>
                    Reset your password
                </h1>
                {emailSent
                    ?   <p className='passwordReset__directions'>
                            We have sent a password reset link to your email. <br/>
                            Please check your inbox.
                        </p>
                    :   <>
                            <TextInput
                                name='email'
                                label='email address'
                                onChange={(event) => setEmail(event.target.value)}
                                required
                                type='email'
                                value={email}
                            />
                            <Button
                                className='passwordReset__button'
                                // disabled={!email}
                                fullWidth
                                // disabled={!email}
                                type='submit'
                            >
                                RESET PASSWORD
                            </Button>
                        </>
                }
                {emailSent &&
                    <div className='passwordReset__action'>
                        <p className='passwordReset__actionText'>
                            Didn't get an email?
                        </p>
                        <a
                            className='passwordReset__actionLink'
                            href='#'
                            onClick={() => {
                                setEmail('');
                                setEmailSent(false);
                            }}
                        >
                            Resend
                        </a>
                    </div>
                }
                <div className='passwordReset__action'>
                    <p className='passwordReset__actionText'>
                        Got your password?
                    </p>
                    <Link to='/signin' className='passwordReset__actionLink'>
                        Back to sign in
                    </Link>
                </div>
            </form>
        </div>
    );
}

export default PasswordReset;